import AcquisitionPendings from "components/Collections/AcquisitionPendings";
import AcquisitionPendingsProducts from "components/Collections/AcquisitionPendingsProducts";
import Acquisitions from "components/Collections/Acquisitions";
import Blacklist from "components/Collections/Blacklist";
import BoundBooks from "components/Collections/BoundBooks";
import Changes from "components/Collections/Changes";
import Custom880Buyers from "components/Collections/Custom880Buyers";
import Customers from "components/Collections/Customers";
import CustomersHistory from "components/Collections/CustomersHistory";
import CustomerDuplicates from "components/Collections/CustomerDuplicates";
import DavidsonsProducts from "components/Collections/DavidsonsProducts";
import DavidsonsCompleted from "components/Collections/DavidsonsCompleted";
import DavidsonsPendingsStaging from "components/Collections/DavidsonsPendingsStaging";
import Dealers from "components/Collections/Dealers";
import DealerDuplicates from "components/Collections/DealerDuplicates"
import Destroys from "components/Collections/Destroys";
import DispositionPendingsFirearms from "components/Collections/DispositionPendingsFirearms";
import DispositionPendingsKiosks from "components/Collections/DispositionPendingsKiosks";
import Dispositions from "components/Collections/Dispositions";
import DispositionsCancels from "components/Collections/DispositionsCancels";
import DispositionsMultipleSales from "components/Collections/DispositionsMultipleSales";
import Emails from "components/Collections/Emails";
import Events from "components/Collections/Events";
import Exports from "components/Collections/Exports";
import FFLLookup from "components/Collections/FFLLookup";
import FirearmTrace from "components/Collections/FirearmTrace";
import Forms from "components/Collections/Forms";
import Inventories from "components/Collections/Inventories";
import Inventory from "components/Collections/Inventory";
import Importers from "components/Collections/Importers";
import Imports from "components/Collections/Imports";
import IoiInspections from "components/Collections/IoiInspections";
import IPBanned from "components/Collections/IPBanned";
import IPWhitelisted from "components/Collections/IPWhitelisted";
import Kiosks from "components/Collections/Kiosks"
import LastFiveTransactions from "components/Collections/LastFiveTransactions";
import LegalEntities from "components/Collections/LegalEntities";
import Locations from "components/Collections/Locations";
import LocationsBoundBookDownloads from "components/Collections/LocationsBoundBookDownloads";
import LocationBoundBookFlags from "./LocationBoundBookFlags";
import LoginRecords from "components/Collections/LoginRecords";
import Logs from "components/Collections/Logs";
import LogsAcquisitions from "components/Collections/LogsAcquisitions";
import LogsCustomer from "components/Collections/LogsCustomer";
import LogsDealers from "components/Collections/LogsDealers";
import LogsDestroys from "components/Collections/LogsDestroys";
import LogsDispositions from "components/Collections/LogsDispositions";
import LogsEvents from "components/Collections/LogsEvents";
import LogsExports from "components/Collections/LogsExports";
import LogsImporters from "components/Collections/LogsImporters";
import LogsLegalEntities from "components/Collections/LogsLegalEntities";
import LogsLocations from "components/Collections/LogsLocations";
import LogsLosses from "components/Collections/LogsLosses";
import LogsProducts from "components/Collections/LogsProducts";
import LogsRentals from "components/Collections/LogsRentals";
import LogsReservations from "components/Collections/LogsReservations";
import LogsUPC from "components/Collections/LogsUPC"
import LogsTransfers from "components/Collections/LogsTransfers";
import Losses from "components/Collections/Losses";
import Manufactureds from "components/Collections/Manufactureds";
import NicsDenied from "components/Collections/NicsDenied";
import Pawns from "components/Collections/Pawns";
import Products from "components/Collections/Products";
import OrdersAmmoready from "components/Collections/OrdersAmmoready";
import OrdersGunbroker from "components/Collections/OrdersGunbroker";
import ProductsAmmoready from "components/Collections/ProductsAmmoready";
import ProductsExisting from "components/Collections/ProductsExisting";
import ProductsForeign from "./ProductsForeign";
import ProductsHistories from "components/Collections/ProductsHistories";
import ProductsPending from "components/Collections/ProductsPending"
import Rentals from "components/Collections/Rentals";
import Reservations from "components/Collections/Reservations";
import TransactionUploads from "components/Collections/TransactionUpload";
import Transfers from "components/Collections/Transfers";
import Trustees from "components/Collections/Trustees";
import TwoStepAuth from "components/Collections/TwoStepAuth";
import UPCS from "components/Collections/UPCS";
import Users from "components/Collections/Users";

const Collections = {
	AcquisitionPendings: AcquisitionPendings,
	AcquisitionPendingsProducts: AcquisitionPendingsProducts,
	Acquisitions: Acquisitions,
	Blacklist: Blacklist,
	BoundBooks: BoundBooks,
	Changes: Changes,
	Custom880Buyers: Custom880Buyers,
	Customers: Customers,
	CustomersHistory: CustomersHistory,
	CustomerDuplicates: CustomerDuplicates,
	DavidsonsCompleted: DavidsonsCompleted,
	DavidsonsProducts: DavidsonsProducts,
	DavidsonsPendingsStaging: DavidsonsPendingsStaging,
	Dealers: Dealers,
	DealerDuplicates:DealerDuplicates,
	Destroys: Destroys,
	DispositionPendingsFirearms: DispositionPendingsFirearms,
	DispositionPendingsKiosks: DispositionPendingsKiosks,
	Dispositions: Dispositions,
	DispositionsCancels: DispositionsCancels,
	DispositionsMultipleSales: DispositionsMultipleSales,
	Emails: Emails,
	Events: Events,
	Exports: Exports,
	FFLLookup: FFLLookup,
	FirearmTrace: FirearmTrace,
	Forms: Forms,
	Inventories: Inventories,
	Inventory: Inventory,
	Imports: Imports,
	Importers: Importers,
	IoiInspections: IoiInspections,
	IPBanned: IPBanned,
	IPWhitelisted: IPWhitelisted,
	Kiosks: Kiosks,
	LastFiveTransactions: LastFiveTransactions,
	LegalEntities: LegalEntities,
	Locations: Locations,
	LocationsBoundBookDownloads: LocationsBoundBookDownloads,
	LocationBoundBookFlags: LocationBoundBookFlags,
	LoginRecords: LoginRecords,
	Logs: Logs,
	LogsAcquisitions: LogsAcquisitions,
	LogsCustomer: LogsCustomer,
	LogsDealers: LogsDealers,
	LogsDestroys: LogsDestroys,
	LogsDispositions: LogsDispositions,
	LogsEvents: LogsEvents,
	LogsExports: LogsExports,
	LogsImporters: LogsImporters,
	LogsLegalEntities: LogsLegalEntities,
	LogsLocations: LogsLocations,
	LogsLosses: LogsLosses,
	LogsProducts: LogsProducts,
	LogsRentals: LogsRentals,
	LogsReservations: LogsReservations,
	LogsUPC : LogsUPC,
	LogsTransfers: LogsTransfers,
	Losses: Losses,
	Manufactureds: Manufactureds,
	NicsDenied: NicsDenied,
	Pawns: Pawns,
	Products: Products,
	OrdersAmmoready: OrdersAmmoready,
	OrdersGunbroker: OrdersGunbroker,
	ProductsAmmoready: ProductsAmmoready,
	ProductsExisting: ProductsExisting,
	ProductsForeign: ProductsForeign,
	ProductsHistories: ProductsHistories,
	ProductsPending: ProductsPending,
	Rentals: Rentals,
	Reservations: Reservations,
	TransactionUploads: TransactionUploads,
	Transfers: Transfers,
	Trustees: Trustees,
	TwoStepAuth: TwoStepAuth,
	UPCS: UPCS,
	Users: Users,
};

export default Collections;
